const { cELM, Wrap4Arrow, isNone, unique } = require("../../utils");
const Chat = require("../../chat");

class MultiSelectObject {
  constructor(data) {
    this._data = data;
    this.options = unique(this._data.values);
    this.element = cELM("div", "option-block");
    this.selectedOptions = [];

    this.preSelectedOptions = Array.isArray(this._data.preSelectedValues)
      ? unique(this._data.preSelectedValues).map(v => v.name || v.value)
      : [];

    this.createElement();
  }

  createElement() {
    const _self = this;
    const btnEl = cELM("div", "continue-button", getLngTxt("button.continue"));
    const btnWrp = Wrap4Arrow(btnEl);

    let nonEls = [];

    this.options.forEach(option => {
      if (!option) {
          return;
      }

      const optionValue = (option.name || option.value || '').trim();

      if (!optionValue) {
        return;
      }

      const _el = cELM("div", "option");
      _el.value = optionValue;

      if (isNone(option)) {
        // if it's special option clearing all others
        nonEls.push(_el);
        _el.onclick = function(evt) {
          let sibling = _el.parentNode.firstChild;
          while (sibling) {
            sibling.classList.remove("option-active");
            sibling = sibling.nextSibling;
          }
          _self.selectedOptions = [option];
          _el.classList.add("option-active");

          btnEl.classList.add("continue-button-active");
          btnWrp.classList.add("arrow-active");
        };
      } else {
        _el.onclick = function(evt) {
          _el.classList.toggle("option-active");

          if (_self.selectedOptions && _self.selectedOptions.length == 1) {
            const [currentSelectedOption] = _self.selectedOptions;
            if (isNone(currentSelectedOption)) {
              _self.selectedOptions = [];
            }
          }

          const index = _self.selectedOptions.indexOf(option);
          if(index !== -1) {
            // Remove from array
            _self.selectedOptions.splice(index, 1);
          }
          else {
            _self.selectedOptions.push(option);
          }

          if (!isNone(option)) {
            for(const nonElement of nonEls) {
                nonElement.classList.remove("option-active");
            }
          }

          const allDeselected = !isNone(option) && _self.selectedOptions.length === 0;
          if (allDeselected) {
            // If all are deselected don't let the user continue
            btnEl.classList.remove('continue-button-active');
            btnWrp.classList.remove('arrow-active');
            return;
          }

          btnEl.classList.add("continue-button-active");
          btnWrp.classList.add("arrow-active");
        };
      }

      _el.innerHTML = '<div class="option-icon"></div><div class="option-text">' + optionValue + "</div>";

      const isPreSelectedOption = _self.preSelectedOptions.includes(optionValue);

      if (isPreSelectedOption) {
        _el.classList.toggle("option-active");
        _self.selectedOptions.push(option);
        btnEl.classList.add("continue-button-active");
        btnWrp.classList.add("arrow-active");
      }

      this.element.addELM(_el);
    });

    btnWrp.onclick = function(evt) {
      if (btnEl.classList.contains("continue-button-active")) {
            Chat.default.send({
                selectedOptions: _self.selectedOptions,
                id:_self._data.id},
                null,
                _self.element);
      }
    };

    this.element.addELM(btnWrp);
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    return this.element;
  }

  reset() {
    let sibling = this.element.firstChild;
    while (sibling) {
      sibling.classList.remove("option-active");
      sibling.classList.remove("continue-button-active");
      sibling.classList.remove("arrow-active");

      sibling = sibling.nextSibling;
    }
    this.selectedOptions = [];
  }

  focus() {}
}

module.exports = MultiSelectObject;
